import {Component, inject, input} from '@angular/core';
import {LeadResources} from '../../../../resources/lead.resources';
import {NgIf, NgSwitch, NgSwitchCase} from '@angular/common';
import {LpButtonComponent} from '../../common/lp/lp-button/lp-button.component';
import {ShowEventDate} from '../../../../common/pipe/showEventDate.pipe';
import {ShowEventDatetime} from '../../../../common/pipe/showEventDatetime.pipe';
import {ShowPricePipe} from '../../../../common/pipe/showPrice.pipe';
import {Router, RouterLink} from '@angular/router';
import {SessionResources} from '../../../../resources/session.resources';
import {LeadService} from '../../../../services/lead.service';

@Component({
  selector: 'app-sub-v2-thanks',
  imports: [
    NgIf,
    LpButtonComponent,
    ShowEventDate,
    ShowEventDatetime,
    ShowPricePipe,
    RouterLink,
    NgSwitch,
    NgSwitchCase
  ],
  templateUrl: './sub-v2-thanks.component.html',
})
export class SubV2ThanksComponent {
  sessionId = input<string>()
  referralCode = input<string>()
  leadResources = inject(LeadResources)
  leadService = inject(LeadService)
  sessionResources = inject(SessionResources)
  router = inject(Router)

  async subscribeFriendNow() {
    await this.leadService.clearLeads()
    this.leadResources.currentLead.reload()

    let hostReferralCode = this.leadResources.currentLead.value()?.subscription?.referralCode
    if(this.referralCode()) {
      hostReferralCode = this.referralCode()
    }
    await this.router.navigate(['/subscribe-v2', this.sessionId(), 'who'], {
      queryParams: {
        referralCode: hostReferralCode
      }
    })
  }
}
